const EDITABLE_SHORTCUT_TARGET_SELECTOR = 'input, textarea, select, [contenteditable="true"]';

interface ScopedViewerKeyboardShortcutOptions {
  allowWhenViewerMounted?: boolean;
}

export const isFindKeyboardShortcut = (event: KeyboardEvent) =>
  event.key.toLowerCase() === 'f' && (event.metaKey || event.ctrlKey);

export const isScopedViewerKeyboardShortcut = (
  viewerElement: HTMLElement | null,
  event: KeyboardEvent,
  options: ScopedViewerKeyboardShortcutOptions = {}
): boolean => {
  if (!viewerElement) {
    return false;
  }

  const ownerWindow = viewerElement.ownerDocument.defaultView;
  if (!ownerWindow) {
    return false;
  }

  const { activeElement } = viewerElement.ownerDocument;
  const activeElementIsInViewer = activeElement instanceof ownerWindow.Node && viewerElement.contains(activeElement);
  const eventTargetIsInViewer = event.target instanceof ownerWindow.Node && viewerElement.contains(event.target);
  const activeElementIsEditable =
    activeElement instanceof ownerWindow.Element && Boolean(activeElement.closest(EDITABLE_SHORTCUT_TARGET_SELECTOR));

  if (activeElementIsEditable && !activeElementIsInViewer) {
    return false;
  }

  if (options.allowWhenViewerMounted) {
    return true;
  }

  return activeElementIsInViewer || eventTargetIsInViewer || viewerElement.matches(':hover');
};
